import type { ReactNode } from "react";

/**
 * A whole-page message, where a screen would have been (`page-state` in DESIGN.md).
 *
 * For the two moments there is no screen to show: an address that matches
 * none, and a screen that broke while drawing. Both used to be one sentence in
 * a bordered box, which read as a screen that had not finished loading rather
 * than as an answer — and gave no way out except the rail.
 */
export function PageState({
  title,
  children,
  actions,
}: {
  readonly title: string;
  /** What happened, in the reader's terms. */
  readonly children: ReactNode;
  /** The way out. At least one, or the page is a dead end. */
  readonly actions: ReactNode;
}) {
  return (
    <div className="page-state">
      <div className="container narrow">
        <h1 className="page-state-title">{title}</h1>
        <div className="page-state-body">{children}</div>
        <div className="button-row">{actions}</div>
      </div>
    </div>
  );
}
